import script from "./earnDeductType.vue?vue&type=script&setup=true&lang=js"
export * from "./earnDeductType.vue?vue&type=script&setup=true&lang=js"

import "./earnDeductType.vue?vue&type=style&index=0&id=769970b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-769970b8"]])

export default __exports__